function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Trustly = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, React) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = void 0;
  React = _interopRequireWildcard(React);

  function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

  function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

  function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

  var SvgTrustly = function SvgTrustly(props) {
    return /*#__PURE__*/React.createElement("div", {
      className: props.className,
      style: props.style
    }, /*#__PURE__*/React.createElement("svg", _extends({
      viewBox: "0 0 40 26",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/React.createElement("rect", {
      width: 40,
      height: 26,
      fill: "#0EE06E"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M9.18076 20.5235V15.8617H7.5V14.8396H11.9688V15.8617H10.288V20.5235H9.18076Z",
      fill: "black"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.8435 20.5236V16.3955H12.8713V17.0485C13.1381 16.4977 13.4732 16.3955 13.8309 16.3955H14.2341V17.429H13.882C13.3596 17.429 12.8997 17.7299 12.8997 18.6441V20.5179H11.8435V20.5236Z",
      fill: "black"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14.8135 19.0302V16.4012H15.8696V18.7804C15.8696 19.3085 16.1422 19.6605 16.6248 19.6605C17.0905 19.6605 17.4368 19.3085 17.4368 18.7861V16.3955H18.4987V20.5236H17.4766V20.0012C17.2097 20.4157 16.8009 20.6145 16.2841 20.6145C15.4154 20.6145 14.8135 20.0353 14.8135 19.0302Z",
      fill: "black"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19.0557 19.3539L19.9869 19.1438C20.0323 19.5072 20.3276 19.7514 20.8216 19.7514C21.2248 19.7514 21.4576 19.581 21.4576 19.3596C21.4576 19.1779 21.3497 19.0586 20.9579 18.9621L20.2878 18.8088C19.5042 18.6271 19.1352 18.258 19.1352 17.5709C19.1352 16.8725 19.72 16.316 20.7875 16.316C21.9175 16.316 22.3831 16.9861 22.4456 17.4687L21.5143 17.6731C21.4689 17.4176 21.2759 17.1451 20.7648 17.1451C20.4298 17.1451 20.18 17.2984 20.18 17.5198C20.18 17.7129 20.3276 17.8208 20.5547 17.8776L21.4632 18.0933C22.173 18.2637 22.5137 18.6782 22.5137 19.2858C22.5137 19.9501 21.9743 20.6031 20.8273 20.6031C19.5781 20.6031 19.1124 19.8593 19.0557 19.3539Z",
      fill: "black"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M24.6938 20.5236C23.984 20.5236 23.5354 20.1205 23.5354 19.3652V17.3154H22.8484V16.3955H23.5354V15.4529L24.5916 15.152V16.3955H25.432V17.3154H24.5916V19.1835C24.5916 19.4845 24.7392 19.6037 25.0458 19.6037H25.5058V20.5236H24.6938V20.5236Z",
      fill: "black"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M26.1929 20.5235V14.8396H27.2491V20.5235H26.1929Z",
      fill: "black"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M30.7465 16.3955H31.8822L30.139 21.9999H29.0033L29.486 20.5236H28.9125L27.7371 16.3955H28.8727L29.7699 19.6435L30.7465 16.3955Z",
      fill: "black"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13.865 7.82146H17.9363V4.5735L21.1843 7.82146L17.9363 11.0694V12.7275H21.877V7.82146H25.4997V4H13.865V7.82146Z",
      fill: "black"
    })));
  };

  var _default = SvgTrustly;
  _exports["default"] = _default;
});